const CAUSES_IDENTIFIERS = {
  USER_CANCELLATION_CAUSE: '62bdc33fb884687233f2b56f',
  BANK_CANCELLATION_CAUSE: '66e94b93a44095c1a9da66a6',
};

const CAUSES_IDENTIFIERS_ENUM = Object.keys(CAUSES_IDENTIFIERS);
const CAUSES_IDENTIFIERS_IDS_ENUM = Object.values(CAUSES_IDENTIFIERS);

export {
  CAUSES_IDENTIFIERS,
  CAUSES_IDENTIFIERS_ENUM,
  CAUSES_IDENTIFIERS_IDS_ENUM,
};
